import { useCallback, useState } from 'react';

const STORAGE_KEY = 'bb_sidebar_collapsed';

function readStored(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch (err) {
    // Private browsing can throw on any storage access; an expanded sidebar is the safe default.
    return false;
  }
}

/** Desktop sidebar fold state, remembered across sessions. */
export function useSidebarCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState<boolean>(readStored);
  const toggle = useCallback(() => {
    setCollapsed((current) => {
      const next = !current;
      try {
        window.localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch (err) {
        // The fold still applies for this session; only persistence is lost.
        console.warn('Could not save the sidebar preference.', err);
      }
      return next;
    });
  }, []);
  return [collapsed, toggle];
}
